<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings,NPS Style Exhibit Bases"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>The National Park Service uses two “wayside interpretive exhibit" base styles – “traditional low-
          profile" and “cantilever low-profile." Our NPS Style exhibit bases have a full metal backing and
          are made for use with 1/8" thick sign panels. Standard finish is a black powder coat. Custom
          sizes, finishes, and surface-mount options are available (45-degree angle is standard, 30-degee
          is optional). The bases are constructed of 10% recycled aluminum extrusion. The exhibit base is
          used with frames that are 18" to 24" high and 24," 36," and 42" wide. The interpretive sign
          panels are easily installed by removing the top section of the frame, inserting the sign panel,
          and replacing the top section. All of these mountings can be in-ground or surface mounted.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
        <div><br>
          <div class="title-underline">Traditional Bases</div>
          <div>This is the original low-profile exhibit base. The frame is attached between two "side-rail" legs and the
            legs extend down from the horizontal center line of the frame. Mounting height from ground level to
            the bottom edge of the frame is 28" to 32."</div>
        </div><br>
        <div>
          <div class="title-underline">Cantilever Bases</div>
          <div>The Cantilever exhibit base has become very popular. The design is simple and unobtrusive. The frame is
            attached between two angled legs. Mounting height from ground level to the bottom edge of the frame
            is 28" to 32."</div>
        </div><br>
        <div>
          <div class="title-underline">Upright Bases</div>
          <div>Signs may also be mounted vertically upright, between two posts. The same material and finish
            specifications apply to upright mountings. Surface mountings are also available for upright signs. In
            addition, upright signs can be mounted as a single sign or grouped together in a sequence of sign panels
            by using additional upright posts.</div>
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img nps-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/nps/traditional-exhibit-base-with-frame.jpg') + ')'}"></div>
              <span class="no-link">Traditional Base</span>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img nps-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/nps/cantilever-exhibit-base-with-frame.jpg') + ')'}"></div>
              <span class="no-link">Cantilever Base</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img nps-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/nps/sled-base-with-frame.jpg') + ')'}"></div>
              <span class="no-link">Sled Base</span>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img nps-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/nps/upright-exhibit-base-with-frame.jpg') + ')'}"></div>
              <span class="no-link">Upright Bases</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 image-pod">
              <div class="img nps-50-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/nps/triangle-exhibit-base-with-frames.jpg') + ')'}"></div>
              <span class="no-link">Multi-Sided Upright Bases</span>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'NPS Style Exhibit Bases'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Nps.vue